import React, { useState, useEffect, useRef } from "react";
import api from "../../../config/axiosConfig";
import { Row, Col } from "react-bootstrap";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FaIndianRupeeSign } from "react-icons/fa6";
import Footer from "../Footer/Footer";
import Header from "../Header";
import "../../../index.css";
import Select from "react-select";
import vegimg from "../../../assets/food/veg.png"
import nonvegimg from "../../../assets/food/nonveg.png"
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

function Food() {
  const pdfContentRef = useRef(null);
  const [Loader, setLoader] = useState(false);
  const [showPdfContent, setShowPdfContent] = useState(false);
  const [foodByCategory, setFoodByCategory] = useState({});
  const [visibleDescriptions, setVisibleDescriptions] = useState({});
  const [media, setMedia] = useState({});
  const [filterType, setFilterType] = useState("All");
  const [foodByFilter, setFoodByFilter] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]); // To track selected categories

  const handleDescriptionToggle = (itemId) => {
    setVisibleDescriptions((prev) => ({
      ...prev,
      [itemId]: !prev[itemId], // Toggle the visibility of the clicked item
    }));
  };

  useEffect(() => {
    const fetchFood = async () => {
      try {
        const fetchedItems = await api.get("/items/joined");
        const fetchMedia = await api.get("/media");
        const categoriesResponse = await api.get("/categories");
        const filterResponse = await api.get("/filters");

        const categories = categoriesResponse.data;
        const filters = filterResponse.data;
        setFoodByFilter(filters);

        // Create a media map using itemId as key
        const mediaMap = fetchMedia.data.reduce((acc, media) => {
          acc[media.itemId] = media.path;
          return acc;
        }, {});
        setMedia(mediaMap);

        // Filter for food items
        const foodItems = fetchedItems.data.filter(
          (item) => item.itemtype_name === "Food & Beverage"
        );

        // Create a category rank map
        const categoryRankMap = categories.reduce((acc, category) => {
          acc[category.name] = category.rank;
          return acc;
        }, {});

        // Group and sort food items by category rank
        const groupedByCategory = foodItems.reduce((acc, item) => {
          const category = item.category_name || "Uncategorized";
          if (!acc[category]) {
            acc[category] = [];
          }
          acc[category].push(item);
          return acc;
        }, {});

        // Sort categories by rank
        const sortedCategories = Object.entries(groupedByCategory)
          .sort(([categoryA], [categoryB]) => {
            const rankA = categoryRankMap[categoryA] || 9999;
            const rankB = categoryRankMap[categoryB] || 9999;
            return rankA - rankB;
          })
          .reduce((acc, [category, items]) => {
            acc[category] = items;
            return acc;
          }, {});

        setFoodByCategory(sortedCategories);
      } catch (error) {
        console.error("Error fetching category:", error);
      }
    };

    fetchFood();
  }, []);

  const filterItems = (items) => {
    let filtered = items;

    // Filter based on selected categories
    if (selectedCategories.length > 0) {
      filtered = filtered.filter(item => selectedCategories.includes(item.category_name));
    }

    // Filter based on selected filters
    if (selectedFilters.length > 0) {
      filtered = filtered.filter(item => {
        // Ensure item.filters is an array, defaulting to an empty array if it's not
        const itemFilters = Array.isArray(item.filters) ? item.filters : [];
        return selectedFilters.some(filterValue => itemFilters.includes(filterValue));
      });
    }
    
    return filtered;
  };

  const filterOptions = foodByFilter.map((filter) => ({
    value: filter.id,
    label: filter.name,
  }));

  // Map categories for react-select dropdown
  const categoryOptions = Object.keys(foodByCategory).map((category) => ({
    value: category,
    label: category,
  }));

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#383838", // Dark background for the control
      border: "1px solid #e6be80",
      borderRadius: "5px",
      padding: "5px 10px",
      boxShadow: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#e6be80", // Golden color for the dropdown indicator (arrow)
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      backgroundColor: "#e6be80", // Golden separator between the indicator and input
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#1c1c1c", // Dark background for the dropdown menu
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#e6be80" : "#1c1c1c", // Change color on hover/selection
      color: state.isSelected ? "#1c1c1c" : "#e6be80", // Text color when selected
      padding: "10px 20px",
      cursor: "pointer",
      borderRadius: "5px",
      ":hover": {
        backgroundColor: "#e6be80", // Hover effect
        color: "#1c1c1c",
      },
    }),
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Notify us before 24 hours
    </Tooltip>
  );

  const downloadPDF = () => {
    const pdfContent = pdfContentRef.current;
    if (!pdfContent) return;

    setLoader(true);
    setShowPdfContent(true);

    setTimeout(() => {
      html2canvas(pdfContent, { scale: 2 }).then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 0.9);
        const pdf = new jsPDF("p", "mm", "a4");

        const imgWidth = 210; // A4 width in mm
        const pageHeight = 297; // A4 height in mm
        let imgHeight = (canvas.height * imgWidth) / canvas.width;
        let yPosition = 0;

        while (yPosition < imgHeight) {
          pdf.addImage(imgData, "JPEG", 0, -yPosition, imgWidth, imgHeight);
          yPosition += pageHeight; // Move to the next section
          if (yPosition < imgHeight) {
            pdf.addPage();
          }
        }

        pdf.save("food-menu.pdf");

        setTimeout(() => {
          setLoader(false);
          setShowPdfContent(false);
        }, 1000);
      });
    }, 500);
  };

  return (
    <>
      <Header />
      <div className="food-section">
        <div className="text-center foodheaderdiv">
          {/* <h2 className="bannar-text pb-5">Menu</h2> */}
          <div className="food-filter-buttons d-flex justify-content-center gap-3 mb-4 flex-wrap" style={{ position: "relative", top: "70px" }}>
            {/* Category Filter Dropdown */}
            <div className="category-filter">
              <Select
                isMulti
                options={categoryOptions}
                onChange={(selectedOptions) => {
                  const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                  setSelectedCategories(selectedValues);
                }}
                className="p-0 m-0"
                placeholder="Select categories"
                styles={{ ...customStyles, padding: "0 !important"}}
              />
            </div>
        {/* Filters */}
        <div className="filter-selection p-0">
          <Select
            isMulti
            options={filterOptions}
            onChange={(selectedOptions) => {
              const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
              setSelectedFilters(selectedValues);
            }}
            placeholder="Select filters"
            styles={customStyles} 
            className="p-0 m-0"
          />
        </div>
            <div>
              <button
                onClick={downloadPDF}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#e6be80",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Download PDF
              </button>

              {Loader && (
                <div className="loader-overlay">
                  <div className="loader"></div>
                  <p style={{ color: "#fff", marginTop: "10px" }}>Generating PDF...</p>
                </div>
              )}

              <div ref={pdfContentRef} style={{ display: "block" }}>
                {/* Your PDF content here */}
              </div>

              <style>
                {`
          .loader-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.7);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            z-index: 9999;
          }

          .loader {
            border: 5px solid rgba(255, 255, 255, 0.3);
            border-top: 5px solid #e6be80;
            border-radius: 50%;
            width: 50px;
            height: 50px;
            animation: spin 1s linear infinite;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>

                {/* download pdf btn */}

        </div>
        </div>

        <div className="foodparalax px-md-5 px-3 pb-5">
          <div className="container-fluid px-md-5 px-3">
            <Row className="g-4">
              {Object.keys(foodByCategory).length > 0 ? (
                Object.entries(foodByCategory).map(([category, items], index) => {
                  const filteredItems = filterItems(items); // Apply filter here
                  if (filteredItems.length === 0) return null; // Skip empty categories

                  return (
                    <Col xl={4} lg={6} key={index}>
                      <div className="h-100">
                        <div className="p-md-5 p-3 food-div">
                          <h4 className="text-white pb-3 foodheading">{category}</h4>
                          <ul className="ps-0">
                            {filteredItems.map((item, idx) => (
                              <li
                                className="d-flex gap-4 align-items-start justify-content-start py-3"
                                key={idx}
                                style={{ borderBottom: "1px solid #ffffff40" }}
                              >
                                <div className="d-flex flex-column food-box w-100">
                                  <div className="d-flex align-items-center justify-content-between gap-2 ">
                                    
                                    <div className="d-flex align-items-start justify-content-start gap-3 flex-row" style={{width:"80%"}}>
                                    {Array.isArray(item.filters) && (
                                        <span className="veg-dot">
                                          <img
                                            src={item.filters.includes(1) ? vegimg : nonvegimg}
                                            alt={item.filters.includes(1) ? "Veg Food" : "Non-Veg Food"}
                                            style={{ width: "15px", height: "15px" }}
                                          />
                                        </span>
                                      )}
                                      <div className="">
                                      <h6
                                        className="food-name"
                                        style={{
                                          cursor: "pointer",
                                          color: "#e6be80",
                                          marginBottom: "0",
                                        }}
                                        onClick={() => handleDescriptionToggle(item.item_id)}
                                      >
                                        {item.item_name}
                                      </h6>
                                      <small className="text-white opacity-50 smalltext">
                                            {[
                                              item.minquantity != null ? `MinQty: ${item.minquantity}` : null,
                                              (item.ordernoticeperiod === 24 || item.ordernoticeperiod === 48)
                                                ? `Notice Period: ${item.ordernoticeperiod === 24 ? "24Hrs" : "48Hrs"}`
                                                : null,
                                              Array.isArray(item.availability) && item.availability.length > 0
                                                ? `Availability: ${item.availability.join(", ")}`
                                                : null,
                                            ]
                                              .filter(Boolean) // Remove null/undefined values
                                              .join(" | ") // Add ' | ' only between existing values
                                            }
                                          </small>
                                      <p className="mb-0">
                                         {visibleDescriptions[item.item_id] && (
                                    <small className="text-sm text-white">
                                      {item.shortdesc}
                                    </small>
                                  )}      
                                        </p>                 
                                      </div>                            
                                    </div>
                                     {/* <div style={{width:"20%", display:"flex", justifyContent:"end"}}>                      
                                       <p
                        className="food-name text-white p-0 m-0" style={{fontSize:"17px"}}
                      >
                         {item.perpersonrateINR ?`₹ ${item.perpersonrateINR}` : "-"}
                      </p>
                                     </div> */}
                                  </div>

                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </Col>
                  );
                })
              ) : (
                <p>Loading...</p>
              )}
            </Row>
          </div>
        </div>
        {/* pdf generate code */}
        <div ref={pdfContentRef} style={{ display: showPdfContent ? "block" : "none"}}>
  <div className="pdf-menu p-4">
    <div>
      <h3 className="px-5 pt-5" style={{ color: "#e6be80" }}>Food Menu</h3>
    </div>
    <div className="food-grid p-4">
    {Object.entries(foodByCategory).map(([category, items], index) => {
        const filteredItems = filterItems(items); // Apply filtering

        if (filteredItems.length === 0) return null; // Skip empty categories

        return (
          <div className="food-column m-3" key={index}>
            <h4 className="text-black p-0 foodheading" style={{ fontSize: "30px" }}>{category}</h4>
            <ul className="ps-0">
              {filteredItems.map((item, idx) => (
                <li className="food-item" key={idx}>
                  <div className="d-flex flex-row align-items-center justify-content-between gap-2 food-box">
                    <div className="d-flex align-items-start gap-1 flex-column">
                    
                      <div
                        className="food-name text-black p-0 m-0 d-flex align-items-center gap-2 justify-content-start" style={{fontSize:"22px"}}
                      >
                        {Array.isArray(item.filters) && (
                                        <span className="veg-dot">
                                          <img
                                            src={item.filters.includes(1) ? vegimg : nonvegimg}
                                            alt={item.filters.includes(1) ? "Veg Food" : "Non-Veg Food"}
                                            style={{ width: "15px", height: "15px" }}
                                          />
                                        </span>
                                      )}
                        {item.item_name}
                      </div>
                      <small className="text-black opacity-50 smalltext" style={{fontSize:"17px"}}>
                                            {[
                                              item.minquantity != null ? `MinQty: ${item.minquantity}` : null,
                                              (item.ordernoticeperiod === 24 || item.ordernoticeperiod === 48)
                                                ? `Notice Period: ${item.ordernoticeperiod === 24 ? "24Hrs" : "48Hrs"}`
                                                : null,
                                              Array.isArray(item.availability) && item.availability.length > 0
                                                ? `Availability: ${item.availability.join(", ")}`
                                                : null,
                                            ]
                                              .filter(Boolean) // Remove null/undefined values
                                              .join(" | ") // Add ' | ' only between existing values
                                            }
                                          </small>
                    </div>
                    <p
                        className="food-name text-black p-0 m-0" style={{fontSize:"22px"}}
                      >
                        {item.perpersonrateINR ? `₹ ${item.perpersonrateINR}` : "-"}
                      </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
    <div className="icondiv d-flex justify-content-center align-items-center gap-3 p-4">
         <div className="iconbox d-flex flex-column align-items-center justify-contnet-center gap-3">
           <img src={ vegimg}
           style={{ width: "20px", height: "20px" }}
           />
           <span className="text-black">Veg Food</span>
         </div>
         <div className="iconbox d-flex flex-column align-items-center justify-contnet-center gap-3">
           <img src={ nonvegimg}
           style={{ width: "20px", height: "20px" }}
           />
           <span className="text-black">Non-Veg Food</span>
         </div>
    </div>
  </div>
</div>


      </div>
      <Footer />
    </>
  );
}

export default Food;
